<div class="dashboard-content sdk-documentation" style="padding: 120px 40px 50px">
  <!-- Main Content -->
  <main class="doc-content">
    <!-- Overview Section -->
    <section *ngIf="activeSection === 'overview'" class="doc-section">
      <h1>{{ 'sdk-docs.overview.title' | translate }}</h1>
      <p class="section-intro">{{ 'sdk-docs.overview.intro' | translate }}</p>

      <div class="info-card">
        <h3>{{ 'sdk-docs.overview.what-is' | translate }}</h3>
        <p>{{ 'sdk-docs.overview.what-is-desc' | translate }}</p>
      </div>

      <div class="feature-grid">
        <div class="feature-card">
          <div class="feature-icon">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#5304fb" stroke-width="2">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
            </svg>
          </div>
          <h4>{{ 'sdk-docs.overview.features.secure-auth' | translate }}</h4>
          <p>{{ 'sdk-docs.overview.features.secure-auth-desc' | translate }}</p>
        </div>
        <div class="feature-card">
          <div class="feature-icon">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#5304fb" stroke-width="2">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
              <circle cx="9" cy="7" r="4"></circle>
              <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
              <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
            </svg>
          </div>
          <h4>{{ 'sdk-docs.overview.features.smart-sync' | translate }}</h4>
          <p>{{ 'sdk-docs.overview.features.smart-sync-desc' | translate }}</p>
        </div>
        <div class="feature-card">
          <div class="feature-icon">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#5304fb" stroke-width="2">
              <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
            </svg>
          </div>
          <h4>{{ 'sdk-docs.overview.features.contest-mgmt' | translate }}</h4>
          <p>{{ 'sdk-docs.overview.features.contest-mgmt-desc' | translate }}</p>
        </div>
        <div class="feature-card">
          <div class="feature-icon">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#5304fb" stroke-width="2">
              <circle cx="12" cy="12" r="10"></circle>
              <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
              <line x1="12" y1="17" x2="12.01" y2="17"></line>
            </svg>
          </div>
          <h4>{{ 'sdk-docs.overview.features.quiz-system' | translate }}</h4>
          <p>{{ 'sdk-docs.overview.features.quiz-system-desc' | translate }}</p>
        </div>
        <div class="feature-card">
          <div class="feature-icon">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#5304fb" stroke-width="2">
              <polyline points="20 12 20 22 4 22 4 12"></polyline>
              <rect x="2" y="7" width="20" height="5"></rect>
              <line x1="12" y1="22" x2="12" y2="7"></line>
              <path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"></path>
              <path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"></path>
            </svg>
          </div>
          <h4>{{ 'sdk-docs.overview.features.rewards' | translate }}</h4>
          <p>{{ 'sdk-docs.overview.features.rewards-desc' | translate }}</p>
        </div>
        <div class="feature-card">
          <div class="feature-icon">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#5304fb" stroke-width="2">
              <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
              <line x1="8" y1="21" x2="16" y2="21"></line>
              <line x1="12" y1="17" x2="12" y2="21"></line>
            </svg>
          </div>
          <h4>{{ 'sdk-docs.overview.features.multi-platform' | translate }}</h4>
          <p>{{ 'sdk-docs.overview.features.multi-platform-desc' | translate }}</p>
        </div>
      </div>

      <div class="platforms-overview">
        <h3>{{ 'sdk-docs.overview.supported-platforms' | translate }}</h3>
        <div class="platform-badges">
          <span class="platform-badge web">Web/JavaScript</span>
          <span class="platform-badge react">React Native</span>
          <span class="platform-badge flutter">Flutter</span>
          <span class="platform-badge ios">iOS Swift</span>
          <span class="platform-badge ios">iOS Obj-C</span>
          <span class="platform-badge android">Android Kotlin</span>
          <span class="platform-badge android">Android Java</span>
        </div>
      </div>
    </section>

    <!-- Getting Started Section -->
    <section *ngIf="activeSection === 'getting-started'" class="doc-section">
      <h1>{{ 'sdk-docs.getting-started.title' | translate }}</h1>
      <p class="section-intro">{{ 'sdk-docs.getting-started.intro' | translate }}</p>

      <div class="steps-container">
        <div class="step">
          <div class="step-number">1</div>
          <div class="step-content">
            <h3>{{ 'sdk-docs.getting-started.step1-title' | translate }}</h3>
            <p [innerHTML]="'sdk-docs.getting-started.step1-desc' | translate"></p>
            <div class="code-block">
              <div class="code-header">
                <span>{{ 'sdk-docs.getting-started.required-credentials' | translate }}</span>
              </div>
              <pre><code>API_KEY: "your-api-key-from-developer-page"
APP_ID: "your-application-id"</code></pre>
            </div>
          </div>
        </div>

        <div class="step">
          <div class="step-number">2</div>
          <div class="step-content">
            <h3>{{ 'sdk-docs.getting-started.step2-title' | translate }}</h3>
            <div class="platform-tabs">
              <button *ngFor="let platform of platforms"
                      [class.active]="activePlatform === platform.id"
                      (click)="setActivePlatform(platform.id)">
                {{ platform.label }}
              </button>
            </div>
            <div class="code-block" *ngIf="activePlatform === 'web'">
              <div class="code-header"><span>npm</span></div>
              <pre><code>npm install luqta-sdk</code></pre>
            </div>
            <div class="code-block" *ngIf="activePlatform === 'web'">
              <div class="code-header"><span>CDN (unpkg)</span></div>
              <pre><code>&lt;script src="https://unpkg.com/luqta-sdk&#64;latest/dist/luqta-sdk.min.js"&gt;&lt;/script&gt;</code></pre>
            </div>
            <div class="code-block" *ngIf="activePlatform === 'web'">
              <div class="code-header"><span>CDN (jsDelivr)</span></div>
              <pre><code>&lt;script src="https://cdn.jsdelivr.net/npm/luqta-sdk&#64;latest/dist/luqta-sdk.min.js"&gt;&lt;/script&gt;</code></pre>
            </div>
            <div class="code-block" *ngIf="activePlatform === 'react-native'">
              <div class="code-header"><span>npm</span></div>
              <pre><code>npm install luqta-react-native-sdk</code></pre>
            </div>
            <div class="code-block" *ngIf="activePlatform === 'flutter'">
              <div class="code-header"><span>pubspec.yaml</span></div>
              <pre><code>dependencies:
  luqta_sdk: ^1.0.0</code></pre>
            </div>
            <div class="code-block" *ngIf="activePlatform === 'ios-swift'">
              <div class="code-header"><span>Swift Package Manager</span></div>
              <pre><code>// Package.swift
dependencies: [
  .package(url: "https://github.com/luqta/ios-sdk-swift.git", from: "1.0.0")
]</code></pre>
            </div>
            <div class="code-block" *ngIf="activePlatform === 'ios-swift'">
              <div class="code-header"><span>CocoaPods</span></div>
              <pre><code>pod 'LuqtaSDK', '~&gt; 1.0'</code></pre>
            </div>
            <div class="code-block" *ngIf="activePlatform === 'ios-objc'">
              <div class="code-header"><span>CocoaPods</span></div>
              <pre><code>pod 'LuqtaSDK', '~&gt; 1.0'</code></pre>
            </div>
            <div class="code-block" *ngIf="activePlatform === 'android-kotlin'">
              <div class="code-header"><span>build.gradle.kts (Kotlin DSL)</span></div>
              <pre><code>dependencies &#123;
    implementation("com.luqta:luqta-sdk-android:1.0.0")
&#125;</code></pre>
            </div>
            <div class="code-block" *ngIf="activePlatform === 'android-java'">
              <div class="code-header"><span>build.gradle</span></div>
              <pre><code>dependencies &#123;
    implementation 'com.luqta:luqta-sdk:1.0.0'
&#125;</code></pre>
            </div>
          </div>
        </div>

        <div class="step">
          <div class="step-number">3</div>
          <div class="step-content">
            <h3>{{ 'sdk-docs.getting-started.step3-title' | translate }}</h3>
            <div class="code-block" *ngIf="activePlatform === 'web'">
              <div class="code-header"><span>JavaScript/TypeScript</span></div>
              <pre><code>import &#123; LuqtaClient &#125; from 'luqta-sdk';

const client = new LuqtaClient(&#123;
  apiKey: 'your-api-key',
  appId: 'your-app-id',
  user: &#123;
    email: 'user&#64;example.com',
    // OR phone_number: '+923147940690'
  &#125;,
  production: false // Set to true for production
&#125;);

// Initialize and authenticate
await client.initialize();
console.log('SDK initialized successfully!');</code></pre>
            </div>
            <div class="code-block" *ngIf="activePlatform === 'react-native'">
              <div class="code-header"><span>React Native</span></div>
              <pre><code>import &#123; LuqtaClient &#125; from 'luqta-react-native-sdk';

const client = new LuqtaClient(&#123;
  apiKey: 'your-api-key',
  appId: 'your-app-id',
  user: &#123; email: 'user&#64;example.com' &#125;
&#125;);

await client.initialize();</code></pre>
            </div>
            <div class="code-block" *ngIf="activePlatform === 'flutter'">
              <div class="code-header"><span>Dart</span></div>
              <pre><code>import 'package:luqta_sdk/luqta_sdk.dart';

final client = LuqtaClient(
  config: LuqtaConfig(
    apiKey: 'your-api-key',
    appId: 'your-app-id',
    user: LuqtaUser(email: 'user&#64;example.com'),
  ),
);

await client.initialize();</code></pre>
            </div>
            <div class="code-block" *ngIf="activePlatform === 'ios-swift'">
              <div class="code-header"><span>Swift</span></div>
              <pre><code>import LuqtaSDK

let config = LuqtaConfig(
    apiKey: "your-api-key",
    appId: "your-app-id",
    user: LuqtaConfig.User(email: "user&#64;example.com")
)

let client = try LuqtaClient(config: config)
try await client.initialize()</code></pre>
            </div>
            <div class="code-block" *ngIf="activePlatform === 'ios-objc'">
              <div class="code-header"><span>Objective-C</span></div>
              <pre><code>#import &lt;LuqtaSDK/LuqtaSDK.h&gt;

LuqtaConfig *config = [[LuqtaConfig alloc] initWithApiKey:&#64;"your-api-key"
                                                    appId:&#64;"your-app-id"
                                                    email:&#64;"user&#64;example.com"];

LuqtaClient *client = [[LuqtaClient alloc] initWithConfig:config];
[client initializeWithCompletion:^(NSError *error) &#123;
    if (!error) &#123;
        NSLog(&#64;"SDK initialized successfully!");
    &#125;
&#125;];</code></pre>
            </div>
            <div class="code-block" *ngIf="activePlatform === 'android-kotlin'">
              <div class="code-header"><span>Kotlin</span></div>
              <pre><code>import com.luqta.sdk.LuqtaClient
import com.luqta.sdk.models.LuqtaConfig

val client = LuqtaClient(
    context = applicationContext,
    config = LuqtaConfig.Builder()
        .apiKey("your-api-key")
        .appId("your-app-id")
        .user(UserIdentification(email = "user&#64;example.com"))
        .build()
)

lifecycleScope.launch &#123;
    client.initialize()
&#125;</code></pre>
            </div>
            <div class="code-block" *ngIf="activePlatform === 'android-java'">
              <div class="code-header"><span>Java</span></div>
              <pre><code>import com.luqta.sdk.LuqtaClient;
import com.luqta.sdk.models.LuqtaConfig;

LuqtaConfig config = new LuqtaConfig.Builder()
    .apiKey("your-api-key")
    .appId("your-app-id")
    .user(new UserIdentity("user&#64;example.com", null))
    .build();

LuqtaClient client = new LuqtaClient(context, config);
client.initialize(new InitializeCallback() &#123;
    &#64;Override
    public void onSuccess() &#123;
        Log.d("Luqta", "SDK initialized!");
    &#125;
    &#64;Override
    public void onError(LuqtaException e) &#123;
        Log.e("Luqta", "Init failed: " + e.getMessage());
    &#125;
&#125;);</code></pre>
            </div>
          </div>
        </div>

        <div class="step">
          <div class="step-number">4</div>
          <div class="step-content">
            <h3>{{ 'sdk-docs.getting-started.step4-title' | translate }}</h3>
            <div class="code-block">
              <div class="code-header"><span>{{ 'sdk-docs.getting-started.example-contests' | translate }}</span></div>
              <pre><code>// Get all available contests
const contests = await client.get('/sdk/app/contest/all');

// Participate in a contest
const result = await client.post('/sdk/app/contest/participate', &#123;
  contest_id: 123
&#125;);

// Complete a level
const completion = await client.post('/sdk/app/contest/level/complete', &#123;
  level_id: 456,
  answer: 'user_answer',
  type: 'text'
&#125;);</code></pre>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Configuration Section -->
    <section *ngIf="activeSection === 'configuration'" class="doc-section">
      <h1>{{ 'sdk-docs.configuration.title' | translate }}</h1>
      <p class="section-intro">{{ 'sdk-docs.configuration.intro' | translate }}</p>

      <div class="config-table">
        <h3>{{ 'sdk-docs.configuration.luqta-config-options' | translate }}</h3>
        <table>
          <thead>
            <tr>
              <th>{{ 'sdk-docs.configuration.col-property' | translate }}</th>
              <th>{{ 'sdk-docs.configuration.col-type' | translate }}</th>
              <th>{{ 'sdk-docs.configuration.col-required' | translate }}</th>
              <th>{{ 'sdk-docs.configuration.col-default' | translate }}</th>
              <th>{{ 'sdk-docs.configuration.col-description' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><code>apiKey</code></td>
              <td>string</td>
              <td>{{ 'sdk-docs.configuration.val-yes' | translate }}</td>
              <td>-</td>
              <td>{{ 'sdk-docs.configuration.apikey-desc' | translate }}</td>
            </tr>
            <tr>
              <td><code>appId</code></td>
              <td>string</td>
              <td>{{ 'sdk-docs.configuration.val-yes' | translate }}</td>
              <td>-</td>
              <td>{{ 'sdk-docs.configuration.appid-desc' | translate }}</td>
            </tr>
            <tr>
              <td><code>user.email</code></td>
              <td>string</td>
              <td>{{ 'sdk-docs.configuration.val-conditional' | translate }}</td>
              <td>-</td>
              <td>{{ 'sdk-docs.configuration.email-desc' | translate }}</td>
            </tr>
            <tr>
              <td><code>user.phone_number</code></td>
              <td>string</td>
              <td>{{ 'sdk-docs.configuration.val-conditional' | translate }}</td>
              <td>-</td>
              <td>{{ 'sdk-docs.configuration.phone-desc' | translate }}</td>
            </tr>
            <tr>
              <td><code>production</code></td>
              <td>boolean</td>
              <td>{{ 'sdk-docs.configuration.val-no' | translate }}</td>
              <td>false</td>
              <td>{{ 'sdk-docs.configuration.production-desc' | translate }}</td>
            </tr>
            <tr>
              <td><code>baseURL</code></td>
              <td>string</td>
              <td>{{ 'sdk-docs.configuration.val-no' | translate }}</td>
              <td>Auto-generated</td>
              <td>{{ 'sdk-docs.configuration.baseurl-desc' | translate }}</td>
            </tr>
            <tr>
              <td><code>timeout</code></td>
              <td>number</td>
              <td>{{ 'sdk-docs.configuration.val-no' | translate }}</td>
              <td>30000</td>
              <td>{{ 'sdk-docs.configuration.timeout-desc' | translate }}</td>
            </tr>
            <tr>
              <td><code>headers</code></td>
              <td>object</td>
              <td>{{ 'sdk-docs.configuration.val-no' | translate }}</td>
              <td>&#123;&#125;</td>
              <td>{{ 'sdk-docs.configuration.headers-desc' | translate }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="info-card warning">
        <h4>{{ 'sdk-docs.configuration.user-id-title' | translate }}</h4>
        <p [innerHTML]="'sdk-docs.configuration.user-id-desc' | translate"></p>
        <ul>
          <li><strong>Email:</strong> <span [innerHTML]="'sdk-docs.configuration.user-id-email' | translate"></span></li>
          <li><strong>Phone:</strong> <span [innerHTML]="'sdk-docs.configuration.user-id-phone' | translate"></span></li>
        </ul>
      </div>

      <div class="code-block">
        <div class="code-header"><span>{{ 'sdk-docs.configuration.full-config-example' | translate }}</span></div>
        <pre><code>const client = new LuqtaClient(&#123;
  apiKey: 'sk_live_abc123xyz',
  appId: 'app_12345',
  user: &#123;
    email: 'user&#64;example.com',
    phone_number: '+923147940690'  // Optional if email provided
  &#125;,
  production: true,
  timeout: 60000,
  headers: &#123;
    'X-Custom-Header': 'value'
  &#125;
&#125;);</code></pre>
      </div>

      <h3>{{ 'sdk-docs.configuration.env-urls-title' | translate }}</h3>
      <div class="info-card">
        <p [innerHTML]="'sdk-docs.configuration.env-urls-desc' | translate"></p>
        <ul>
          <li><strong>{{ 'sdk-docs.configuration.env-dev' | translate }}</strong> <code>https://xi5f-5y62-kbyr.n7e.xano.io/api:ev5HkJDh:dev</code></li>
          <li><strong>{{ 'sdk-docs.configuration.env-prod' | translate }}</strong> <code>https://xi5f-5y62-kbyr.n7e.xano.io/api:ev5HkJDh</code></li>
        </ul>
      </div>

      <h3>{{ 'sdk-docs.configuration.runtime-config-title' | translate }}</h3>
      <div class="code-block">
        <div class="code-header"><span>{{ 'sdk-docs.configuration.config-mgmt' | translate }}</span></div>
        <pre><code>// Update API key
client.setApiKey('new-api-key');

// Switch environment
client.setProduction(true);

// Update timeout
client.setTimeout(60000);

// Get current configuration
console.log(client.getApiKey());     // Returns masked: "sk_test_..."
console.log(client.getAppId());
console.log(client.isProduction());
console.log(client.getTimeout());
console.log(client.getBaseURL());</code></pre>
      </div>
    </section>

    <!-- Authentication Section -->
    <section *ngIf="activeSection === 'authentication'" class="doc-section">
      <h1>{{ 'sdk-docs.authentication.title' | translate }}</h1>
      <p class="section-intro">{{ 'sdk-docs.authentication.intro' | translate }}</p>

      <h3>{{ 'sdk-docs.authentication.auth-flow-title' | translate }}</h3>
      <div class="flow-diagram">
        <div class="flow-step">
          <div class="flow-number">1</div>
          <div class="flow-content">
            <h4>{{ 'sdk-docs.authentication.flow-step1-title' | translate }}</h4>
            <p>{{ 'sdk-docs.authentication.flow-step1-desc' | translate }}</p>
          </div>
        </div>
        <div class="flow-arrow">→</div>
        <div class="flow-step">
          <div class="flow-number">2</div>
          <div class="flow-content">
            <h4>{{ 'sdk-docs.authentication.flow-step2-title' | translate }}</h4>
            <p [innerHTML]="'sdk-docs.authentication.flow-step2-desc' | translate"></p>
          </div>
        </div>
        <div class="flow-arrow">→</div>
        <div class="flow-step">
          <div class="flow-number">3</div>
          <div class="flow-content">
            <h4>{{ 'sdk-docs.authentication.flow-step3-title' | translate }}</h4>
            <p>{{ 'sdk-docs.authentication.flow-step3-desc' | translate }}</p>
          </div>
        </div>
        <div class="flow-arrow">→</div>
        <div class="flow-step">
          <div class="flow-number">4</div>
          <div class="flow-content">
            <h4>{{ 'sdk-docs.authentication.flow-step4-title' | translate }}</h4>
            <p>{{ 'sdk-docs.authentication.flow-step4-desc' | translate }}</p>
          </div>
        </div>
      </div>

      <h3>{{ 'sdk-docs.authentication.multi-level-title' | translate }}</h3>
      <p>{{ 'sdk-docs.authentication.multi-level-desc' | translate }}</p>
      <div class="validation-list">
        <div class="validation-item">
          <span class="validation-icon success">✓</span>
          <div>
            <strong>{{ 'sdk-docs.authentication.val-apikey-title' | translate }}</strong>
            <p>{{ 'sdk-docs.authentication.val-apikey-desc' | translate }}</p>
          </div>
        </div>
        <div class="validation-item">
          <span class="validation-icon success">✓</span>
          <div>
            <strong>{{ 'sdk-docs.authentication.val-app-title' | translate }}</strong>
            <p>{{ 'sdk-docs.authentication.val-app-desc' | translate }}</p>
          </div>
        </div>
        <div class="validation-item">
          <span class="validation-icon success">✓</span>
          <div>
            <strong>{{ 'sdk-docs.authentication.val-client-title' | translate }}</strong>
            <p>{{ 'sdk-docs.authentication.val-client-desc' | translate }}</p>
          </div>
        </div>
        <div class="validation-item">
          <span class="validation-icon success">✓</span>
          <div>
            <strong>{{ 'sdk-docs.authentication.val-sub-title' | translate }}</strong>
            <p>{{ 'sdk-docs.authentication.val-sub-desc' | translate }}</p>
          </div>
        </div>
        <div class="validation-item">
          <span class="validation-icon success">✓</span>
          <div>
            <strong>{{ 'sdk-docs.authentication.val-plan-title' | translate }}</strong>
            <p>{{ 'sdk-docs.authentication.val-plan-desc' | translate }}</p>
          </div>
        </div>
      </div>

      <h3>{{ 'sdk-docs.authentication.req-headers-title' | translate }}</h3>
      <div class="code-block">
        <div class="code-header"><span>{{ 'sdk-docs.authentication.req-headers-code' | translate }}</span></div>
        <pre><code>// Standard headers for all requests
Content-Type: application/json
Authorization: Bearer &#123;authToken&#125;
X-Data-Source: live|dev

// Additional headers during initialization
X-App-Token: &#123;appId&#125;
X-User: &#123;JSON.stringify(user)&#125;</code></pre>
      </div>

      <h3>{{ 'sdk-docs.authentication.token-security-title' | translate }}</h3>
      <div class="info-card">
        <h4>{{ 'sdk-docs.authentication.jwe-title' | translate }}</h4>
        <p>{{ 'sdk-docs.authentication.jwe-desc' | translate }}</p>
        <ul>
          <li>{{ 'sdk-docs.authentication.jwe-key-enc' | translate }}</li>
          <li>{{ 'sdk-docs.authentication.jwe-content-enc' | translate }}</li>
          <li>{{ 'sdk-docs.authentication.jwe-ttl' | translate }}</li>
        </ul>
      </div>

      <h3>{{ 'sdk-docs.authentication.token-storage-title' | translate }}</h3>
      <table>
        <thead>
          <tr>
            <th>{{ 'sdk-docs.authentication.col-platform' | translate }}</th>
            <th>{{ 'sdk-docs.authentication.col-storage' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr><td>Web</td><td>Cookies / LocalStorage</td></tr>
          <tr><td>React Native</td><td>AsyncStorage</td></tr>
          <tr><td>Flutter</td><td>Flutter Secure Storage</td></tr>
          <tr><td>iOS</td><td>Keychain</td></tr>
          <tr><td>Android</td><td>SharedPreferences (encrypted)</td></tr>
        </tbody>
      </table>
    </section>

    <!-- API Reference Section -->
    <section *ngIf="activeSection === 'api-reference'" class="doc-section">
      <h1>{{ 'sdk-docs.api-reference.title' | translate }}</h1>
      <p class="section-intro">{{ 'sdk-docs.api-reference.intro' | translate }}</p>

      <div class="api-methods">
        <h3>{{ 'sdk-docs.api-reference.http-methods-title' | translate }}</h3>
        <div class="method-grid">
          <div class="method-card">
            <code class="method-get">GET</code>
            <pre>client.get(endpoint, params?)</pre>
          </div>
          <div class="method-card">
            <code class="method-post">POST</code>
            <pre>client.post(endpoint, body?)</pre>
          </div>
          <div class="method-card">
            <code class="method-put">PUT</code>
            <pre>client.put(endpoint, body?)</pre>
          </div>
          <div class="method-card">
            <code class="method-patch">PATCH</code>
            <pre>client.patch(endpoint, body?)</pre>
          </div>
          <div class="method-card">
            <code class="method-delete">DELETE</code>
            <pre>client.delete(endpoint)</pre>
          </div>
        </div>
      </div>

      <h3>{{ 'sdk-docs.api-reference.available-endpoints-title' | translate }}</h3>
      <div *ngFor="let category of getUniqueCategories()" class="endpoint-category">
        <h4>{{ category }}</h4>
        <div *ngFor="let endpoint of getEndpointsByCategory(category)" class="endpoint-item">
          <div class="endpoint-header" (click)="toggleEndpoint(endpoint.id)">
            <span class="method-badge" [ngClass]="getMethodClass(endpoint.method)">{{ endpoint.method }}</span>
            <code class="endpoint-path">{{ endpoint.path }}</code>
            <span class="endpoint-desc">{{ endpoint.description }}</span>
            <span class="expand-icon">{{ isEndpointExpanded(endpoint.id) ? '−' : '+' }}</span>
          </div>
          <div class="endpoint-details" *ngIf="isEndpointExpanded(endpoint.id)">
            <div *ngIf="endpoint.headers" class="detail-section">
              <h5>{{ 'sdk-docs.api-reference.detail-headers' | translate }}</h5>
              <table class="params-table">
                <tr *ngFor="let header of endpoint.headers">
                  <td><code>{{ header.name }}</code></td>
                  <td>{{ header.value }}</td>
                  <td><span class="required-badge" *ngIf="header.required">{{ 'sdk-docs.api-reference.required-badge' | translate }}</span></td>
                </tr>
              </table>
            </div>
            <div *ngIf="endpoint.params" class="detail-section">
              <h5>{{ 'sdk-docs.api-reference.detail-query-params' | translate }}</h5>
              <table class="params-table">
                <tr *ngFor="let param of endpoint.params">
                  <td><code>{{ param.name }}</code></td>
                  <td>{{ param.type }}</td>
                  <td>{{ param.description }}</td>
                </tr>
              </table>
            </div>
            <div *ngIf="endpoint.body" class="detail-section">
              <h5>{{ 'sdk-docs.api-reference.detail-request-body' | translate }}</h5>
              <pre><code>{{ formatJson(endpoint.body) }}</code></pre>
            </div>
            <div class="detail-section">
              <h5>{{ 'sdk-docs.api-reference.detail-response' | translate }}</h5>
              <pre><code>{{ formatJson(endpoint.response) }}</code></pre>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Data Models Section -->
    <section *ngIf="activeSection === 'data-models'" class="doc-section">
      <h1>{{ 'sdk-docs.data-models.title' | translate }}</h1>
      <p class="section-intro">{{ 'sdk-docs.data-models.intro' | translate }}</p>

      <div class="model-card">
        <h3>UserProfile</h3>
        <p [innerHTML]="'sdk-docs.data-models.user-profile-desc' | translate"></p>
        <div class="code-block">
          <pre><code>interface UserProfile &#123;
  dob?: string | null;           // Date of birth (YYYY-MM-DD)
  name?: string;                 // User's full name
  email?: string;                // Email address
  gender?: string;               // Gender (male/female/other)
  country?: string;              // Country code (e.g., "PK", "US")
  Verified?: boolean;            // Verification status
  image_url?: string;            // Profile image URL
  phone_number?: string;         // Phone (E.164 format)
  interested_in?: string[];      // List of interests
  policy_accept?: boolean;       // Policy acceptance
&#125;</code></pre>
        </div>
      </div>

      <div class="model-card">
        <h3>ApiResponse</h3>
        <p>{{ 'sdk-docs.data-models.api-response-desc' | translate }}</p>
        <div class="code-block">
          <pre><code>interface ApiResponse&lt;T = any&gt; &#123;
  success: boolean;
  data?: T;
  error?: &#123;
    code: string;
    message: string;
  &#125;;
&#125;</code></pre>
        </div>
      </div>

      <div class="model-card">
        <h3>RequestOptions</h3>
        <p [innerHTML]="'sdk-docs.data-models.request-options-desc' | translate"></p>
        <div class="code-block">
          <pre><code>interface RequestOptions &#123;
  method?: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';
  headers?: Record&lt;string, string&gt;;
  body?: any;
  params?: Record&lt;string, string | number | boolean&gt;;
&#125;</code></pre>
        </div>
      </div>

      <div class="model-card">
        <h3>Contest</h3>
        <p>{{ 'sdk-docs.data-models.contest-desc' | translate }}</p>
        <div class="code-block">
          <pre><code>interface Contest &#123;
  id: number;
  name: string;
  arabic_name?: string;
  details: string;
  arabic_details?: string;
  type: 'public' | 'private';
  no_of_users: number;
  format_of_contest: string;
  start_date: string;           // ISO date
  end_date: string;             // ISO date
  prize_announce_date?: string;
  status: 'approved' | 'rejected' | 'pending' | 'draft' | 'completed';
  access_code?: string;         // For private contests
  banners: string[];
  View_Type?: 'VIP' | 'Recent Contest';
&#125;</code></pre>
        </div>
      </div>

      <div class="model-card">
        <h3>Level</h3>
        <p>{{ 'sdk-docs.data-models.level-desc' | translate }}</p>
        <div class="code-block">
          <pre><code>interface Level &#123;
  id: number;
  contest_id: number;
  level_type: 'text' | 'qr' | 'link' | 'image';
  name: string;
  arabic_name?: string;
  description: string;
  points: number;
  start_date: string;
  end_date: string;
  // Type-specific fields
  textContent?: string;         // For text levels
  qrData?: string;              // For QR levels
  link?: string;                // For link levels
  image?: string;               // For image levels
&#125;</code></pre>
        </div>
      </div>

      <div class="model-card">
        <h3>QuizAttempt</h3>
        <p>{{ 'sdk-docs.data-models.quiz-attempt-desc' | translate }}</p>
        <div class="code-block">
          <pre><code>interface QuizAttempt &#123;
  id: number;
  quiz_id: number;
  user_id: number;
  status: 'in_progress' | 'completed';
  score: number;
  percentage: number;
  accuracy: number;
  time_taken: string;           // Formatted: "Xh Ym Zs"
  grade: 'A+' | 'A' | 'B' | 'C' | 'D' | 'F';
  passed: boolean;
  correct_count: number;
  incorrect_count: number;
  unanswered_count: number;
&#125;</code></pre>
        </div>
      </div>
    </section>

    <!-- Error Handling Section -->
    <section *ngIf="activeSection === 'error-handling'" class="doc-section">
      <h1>{{ 'sdk-docs.error-handling.title' | translate }}</h1>
      <p class="section-intro">{{ 'sdk-docs.error-handling.intro' | translate }}</p>

      <h3>{{ 'sdk-docs.error-handling.error-structure-title' | translate }}</h3>
      <div class="code-block">
        <pre><code>interface LuqtaError &#123;
  message: string;      // Human-readable error message
  code: string;         // Error code for programmatic handling
  status?: number;      // HTTP status code (if applicable)
  payload?: any;        // Additional error data from API
&#125;</code></pre>
      </div>

      <h3>{{ 'sdk-docs.error-handling.handling-errors-title' | translate }}</h3>
      <div class="code-block">
        <div class="code-header"><span>{{ 'sdk-docs.error-handling.try-catch' | translate }}</span></div>
        <pre><code>try &#123;
  await client.initialize();
  const contests = await client.get('/sdk/app/contest/all');
&#125; catch (error) &#123;
  if (error.code === 'SDK-AUTH-002') &#123;
    console.error('Invalid API key');
  &#125; else if (error.code === 'SDK-SUB-001') &#123;
    console.error('No active subscription');
  &#125; else &#123;
    console.error('Error: ' + error.message);
  &#125;
&#125;</code></pre>
      </div>

      <h3>{{ 'sdk-docs.error-handling.error-codes-title' | translate }}</h3>
      <div *ngFor="let category of errorCodes" class="error-category">
        <h4>{{ category.category }} Errors</h4>
        <table class="error-table">
          <thead>
            <tr>
              <th>{{ 'sdk-docs.error-handling.col-code' | translate }}</th>
              <th>{{ 'sdk-docs.error-handling.col-desc' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let error of category.codes">
              <td><code>{{ error.code }}</code></td>
              <td>{{ error.message }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

    <!-- Platform Guides Section -->
    <section *ngIf="activeSection === 'platform-guides'" class="doc-section">
      <h1>{{ 'sdk-docs.platform-guides.title' | translate }}</h1>
      <p class="section-intro">{{ 'sdk-docs.platform-guides.intro' | translate }}</p>

      <div class="platform-tabs large">
        <button *ngFor="let platform of platforms"
                [class.active]="activePlatform === platform.id"
                (click)="setActivePlatform(platform.id)">
          {{ platform.label }}
        </button>
      </div>

      <!-- Web/JavaScript Guide -->
      <div *ngIf="activePlatform === 'web'" class="platform-guide">
        <h3>{{ 'sdk-docs.platform-guides.web-title' | translate }}</h3>
        <div class="info-card">
          <h4>{{ 'sdk-docs.platform-guides.features' | translate }}</h4>
          <ul>
            <li>{{ 'sdk-docs.platform-guides.web-f1' | translate }}</li>
            <li>{{ 'sdk-docs.platform-guides.web-f2' | translate }}</li>
            <li>{{ 'sdk-docs.platform-guides.web-f3' | translate }}</li>
            <li>{{ 'sdk-docs.platform-guides.web-f4' | translate }}</li>
            <li>{{ 'sdk-docs.platform-guides.web-f5' | translate }}</li>
            <li>{{ 'sdk-docs.platform-guides.web-f6' | translate }}</li>
          </ul>
        </div>
        <div class="code-block">
          <div class="code-header"><span>{{ 'sdk-docs.platform-guides.complete-example' | translate }}</span></div>
          <pre><code>import &#123; LuqtaClient &#125; from 'luqta-sdk';

// Initialize
const client = new LuqtaClient(&#123;
  apiKey: 'your-api-key',
  appId: 'your-app-id',
  user: &#123; email: 'user&#64;example.com' &#125;
&#125;);

async function main() &#123;
  // Authenticate
  await client.initialize();

  // Sync user profile
  await client.syncUser(&#123;
    name: 'John Doe',
    gender: 'male',
    country: 'US'
  &#125;);

  // Get contests
  const contests = await client.get('/sdk/app/contest/all');
  console.log('Available contests:', contests.data);

  // Participate in contest
  await client.post('/sdk/app/contest/participate', &#123;
    contest_id: contests.data[0].id
  &#125;);

  // Complete a level
  await client.post('/sdk/app/contest/level/complete', &#123;
    level_id: 1,
    answer: 'my answer',
    type: 'text'
  &#125;);
&#125;

main().catch(console.error);</code></pre>
        </div>
      </div>

      <!-- React Native Guide -->
      <div *ngIf="activePlatform === 'react-native'" class="platform-guide">
        <h3>{{ 'sdk-docs.platform-guides.rn-title' | translate }}</h3>
        <div class="info-card">
          <h4>{{ 'sdk-docs.platform-guides.features' | translate }}</h4>
          <ul>
            <li>{{ 'sdk-docs.platform-guides.rn-f1' | translate }}</li>
            <li>{{ 'sdk-docs.platform-guides.rn-f2' | translate }}</li>
            <li>{{ 'sdk-docs.platform-guides.rn-f3' | translate }}</li>
            <li [innerHTML]="'sdk-docs.platform-guides.rn-f4' | translate"></li>
            <li>{{ 'sdk-docs.platform-guides.rn-f5' | translate }}</li>
            <li [innerHTML]="'sdk-docs.platform-guides.rn-f6' | translate"></li>
          </ul>
        </div>
        <div class="code-block">
          <div class="code-header"><span>{{ 'sdk-docs.platform-guides.using-hooks' | translate }}</span></div>
          <pre><code>import &#123; LuqtaClient, useLuqta, useLuqtaMutation &#125; from 'luqta-react-native-sdk';

const client = new LuqtaClient(&#123;
  apiKey: 'your-api-key',
  appId: 'your-app-id',
  user: &#123; email: 'user&#64;example.com' &#125;
&#125;);

function ContestList() &#123;
  const &#123; data, loading, error, refetch &#125; = useLuqta(client, &#123;
    endpoint: '/sdk/app/contest/all',
    autoFetch: true
  &#125;);

  const &#123; mutate, loading: participating &#125; = useLuqtaMutation(client, &#123;
    onSuccess: () =&gt; refetch()
  &#125;);

  const handleParticipate = (contestId) =&gt; &#123;
    mutate('/sdk/app/contest/participate', &#123; contest_id: contestId &#125;);
  &#125;;

  if (loading) return &lt;Text&gt;Loading...&lt;/Text&gt;;
  if (error) return &lt;Text&gt;Error: &#123;error&#125;&lt;/Text&gt;;

  return (
    &lt;FlatList
      data=&#123;data?.data&#125;
      renderItem=&#123;(&#123; item &#125;) =&gt; (
        &lt;TouchableOpacity onPress=&#123;() =&gt; handleParticipate(item.id)&#125;&gt;
          &lt;Text&gt;&#123;item.name&#125;&lt;/Text&gt;
        &lt;/TouchableOpacity&gt;
      )&#125;
    /&gt;
  );
&#125;</code></pre>
        </div>
      </div>

      <!-- Flutter Guide -->
      <div *ngIf="activePlatform === 'flutter'" class="platform-guide">
        <h3>{{ 'sdk-docs.platform-guides.flutter-title' | translate }}</h3>
        <div class="info-card">
          <h4>{{ 'sdk-docs.platform-guides.features' | translate }}</h4>
          <ul>
            <li>{{ 'sdk-docs.platform-guides.flutter-f1' | translate }}</li>
            <li>{{ 'sdk-docs.platform-guides.flutter-f2' | translate }}</li>
            <li>{{ 'sdk-docs.platform-guides.flutter-f3' | translate }}</li>
            <li>{{ 'sdk-docs.platform-guides.flutter-f4' | translate }}</li>
          </ul>
        </div>
        <div class="code-block">
          <div class="code-header"><span>{{ 'sdk-docs.platform-guides.complete-example' | translate }}</span></div>
          <pre><code>import 'package:luqta_sdk/luqta_sdk.dart';

class ContestService &#123;
  late final LuqtaClient _client;

  Future&lt;void&gt; initialize() async &#123;
    _client = LuqtaClient(
      config: LuqtaConfig(
        apiKey: 'your-api-key',
        appId: 'your-app-id',
        user: LuqtaUser(email: 'user&#64;example.com'),
        production: false,
        timeout: Duration(seconds: 30),
      ),
    );
    await _client.initialize();
  &#125;

  Future&lt;List&lt;Contest&gt;&gt; getContests() async &#123;
    final response = await _client.get('/sdk/app/contest/all');
    return (response.data as List)
        .map((json) =&gt; Contest.fromJson(json))
        .toList();
  &#125;

  Future&lt;void&gt; participate(int contestId) async &#123;
    await _client.post('/sdk/app/contest/participate', &#123;
      'contest_id': contestId,
    &#125;);
  &#125;
&#125;</code></pre>
        </div>
      </div>

      <!-- iOS Swift Guide -->
      <div *ngIf="activePlatform === 'ios-swift'" class="platform-guide">
        <h3>{{ 'sdk-docs.platform-guides.ios-swift-title' | translate }}</h3>
        <div class="info-card">
          <h4>{{ 'sdk-docs.platform-guides.features' | translate }}</h4>
          <ul>
            <li>{{ 'sdk-docs.platform-guides.ios-swift-f1' | translate }}</li>
            <li>{{ 'sdk-docs.platform-guides.ios-swift-f2' | translate }}</li>
            <li>{{ 'sdk-docs.platform-guides.ios-swift-f3' | translate }}</li>
            <li>{{ 'sdk-docs.platform-guides.ios-swift-f4' | translate }}</li>
          </ul>
        </div>
        <div class="code-block">
          <div class="code-header"><span>{{ 'sdk-docs.platform-guides.swiftui-example' | translate }}</span></div>
          <pre><code>import SwiftUI
import LuqtaSDK

class ContestViewModel: ObservableObject &#123;
    &#64;Published var contests: [Contest] = []
    &#64;Published var isLoading = false

    private let client: LuqtaClient

    init() throws &#123;
        let config = LuqtaConfig(
            apiKey: "your-api-key",
            appId: "your-app-id",
            user: LuqtaConfig.User(email: "user&#64;example.com")
        )
        self.client = try LuqtaClient(config: config)
    &#125;

    func loadContests() async &#123;
        isLoading = true
        do &#123;
            try await client.initialize()
            let response: ApiResponse&lt;[Contest]&gt; = try await client.get("/sdk/app/contest/all")
            await MainActor.run &#123;
                self.contests = response.data ?? []
                self.isLoading = false
            &#125;
        &#125; catch &#123;
            print("Error: \(error)")
            isLoading = false
        &#125;
    &#125;
&#125;

struct ContestListView: View &#123;
    &#64;StateObject var viewModel = try! ContestViewModel()

    var body: some View &#123;
        List(viewModel.contests) &#123; contest in
            Text(contest.name)
        &#125;
        .onAppear &#123;
            Task &#123; await viewModel.loadContests() &#125;
        &#125;
    &#125;
&#125;</code></pre>
        </div>
      </div>

      <!-- iOS Objective-C Guide -->
      <div *ngIf="activePlatform === 'ios-objc'" class="platform-guide">
        <h3>{{ 'sdk-docs.platform-guides.ios-objc-title' | translate }}</h3>
        <div class="info-card">
          <h4>{{ 'sdk-docs.platform-guides.features' | translate }}</h4>
          <ul>
            <li>{{ 'sdk-docs.platform-guides.ios-objc-f1' | translate }}</li>
            <li>{{ 'sdk-docs.platform-guides.ios-objc-f2' | translate }}</li>
            <li>{{ 'sdk-docs.platform-guides.ios-objc-f3' | translate }}</li>
            <li>{{ 'sdk-docs.platform-guides.ios-objc-f4' | translate }}</li>
          </ul>
        </div>
        <div class="code-block">
          <div class="code-header"><span>{{ 'sdk-docs.platform-guides.usage-example' | translate }}</span></div>
          <pre><code>#import &lt;LuqtaSDK/LuqtaSDK.h&gt;

&#64;interface ContestManager : NSObject
&#64;property (nonatomic, strong) LuqtaClient *client;
&#64;end

&#64;implementation ContestManager

- (void)setup &#123;
    LuqtaConfig *config = [[LuqtaConfig alloc] initWithApiKey:&#64;"your-api-key"
                                                        appId:&#64;"your-app-id"
                                                        email:&#64;"user&#64;example.com"];

    self.client = [[LuqtaClient alloc] initWithConfig:config];

    [self.client initializeWithCompletion:^(NSError *error) &#123;
        if (error) &#123;
            NSLog(&#64;"Init failed: %&#64;", error.localizedDescription);
            return;
        &#125;
        [self loadContests];
    &#125;];
&#125;

- (void)loadContests &#123;
    [self.client get:&#64;"/sdk/app/contest/all"
          parameters:nil
          completion:^(LuqtaApiResponse *response, NSError *error) &#123;
        if (error) &#123;
            NSLog(&#64;"Error: %&#64;", error);
            return;
        &#125;
        NSLog(&#64;"Contests: %&#64;", response.data);
    &#125;];
&#125;

&#64;end</code></pre>
        </div>
      </div>

      <!-- Android Kotlin Guide -->
      <div *ngIf="activePlatform === 'android-kotlin'" class="platform-guide">
        <h3>{{ 'sdk-docs.platform-guides.android-kotlin-title' | translate }}</h3>
        <div class="info-card">
          <h4>{{ 'sdk-docs.platform-guides.features' | translate }}</h4>
          <ul>
            <li>{{ 'sdk-docs.platform-guides.android-kotlin-f1' | translate }}</li>
            <li>{{ 'sdk-docs.platform-guides.android-kotlin-f2' | translate }}</li>
            <li>{{ 'sdk-docs.platform-guides.android-kotlin-f3' | translate }}</li>
            <li>{{ 'sdk-docs.platform-guides.android-kotlin-f4' | translate }}</li>
          </ul>
        </div>
        <div class="code-block">
          <div class="code-header"><span>{{ 'sdk-docs.platform-guides.viewmodel-example' | translate }}</span></div>
          <pre><code>import com.luqta.sdk.LuqtaClient
import com.luqta.sdk.models.*
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow

class ContestViewModel(application: Application) : AndroidViewModel(application) &#123;

    private val client = LuqtaClient(
        context = application,
        config = LuqtaConfig.Builder()
            .apiKey("your-api-key")
            .appId("your-app-id")
            .user(UserIdentification(email = "user&#64;example.com"))
            .build()
    )

    private val _contests = MutableStateFlow&lt;List&lt;Contest&gt;&gt;(emptyList())
    val contests = _contests.asStateFlow()

    private val _loading = MutableStateFlow(false)
    val loading = _loading.asStateFlow()

    fun loadContests() &#123;
        viewModelScope.launch &#123;
            _loading.value = true
            try &#123;
                client.initialize()
                val response = client.get&lt;List&lt;Contest&gt;&gt;("/sdk/app/contest/all")
                _contests.value = response.data ?: emptyList()
            &#125; catch (e: LuqtaException) &#123;
                Log.e("Luqta", "Error: " + e.message)
            &#125; finally &#123;
                _loading.value = false
            &#125;
        &#125;
    &#125;

    fun participate(contestId: Int) &#123;
        viewModelScope.launch &#123;
            try &#123;
                client.post&lt;Unit&gt;("/sdk/app/contest/participate",
                    mapOf("contest_id" to contestId))
            &#125; catch (e: LuqtaException) &#123;
                Log.e("Luqta", "Participation failed: " + e.message)
            &#125;
        &#125;
    &#125;
&#125;</code></pre>
        </div>
      </div>

      <!-- Android Java Guide -->
      <div *ngIf="activePlatform === 'android-java'" class="platform-guide">
        <h3>{{ 'sdk-docs.platform-guides.android-java-title' | translate }}</h3>
        <div class="info-card">
          <h4>{{ 'sdk-docs.platform-guides.features' | translate }}</h4>
          <ul>
            <li>{{ 'sdk-docs.platform-guides.android-java-f1' | translate }}</li>
            <li>{{ 'sdk-docs.platform-guides.android-java-f2' | translate }}</li>
            <li>{{ 'sdk-docs.platform-guides.android-java-f3' | translate }}</li>
            <li>{{ 'sdk-docs.platform-guides.android-java-f4' | translate }}</li>
          </ul>
        </div>
        <div class="code-block">
          <div class="code-header"><span>{{ 'sdk-docs.platform-guides.activity-example' | translate }}</span></div>
          <pre><code>import com.luqta.sdk.LuqtaClient;
import com.luqta.sdk.models.*;
import com.luqta.sdk.callbacks.*;

public class ContestActivity extends AppCompatActivity &#123;

    private LuqtaClient client;

    &#64;Override
    protected void onCreate(Bundle savedInstanceState) &#123;
        super.onCreate(savedInstanceState);
        setContentView(R.layout.activity_contest);

        LuqtaConfig config = new LuqtaConfig.Builder()
            .apiKey("your-api-key")
            .appId("your-app-id")
            .user(new UserIdentity("user&#64;example.com", null))
            .build();

        client = new LuqtaClient(this, config);

        client.initialize(new InitializeCallback() &#123;
            &#64;Override
            public void onSuccess() &#123;
                loadContests();
            &#125;

            &#64;Override
            public void onError(LuqtaException e) &#123;
                Log.e("Luqta", "Init failed: " + e.getMessage());
            &#125;
        &#125;);
    &#125;

    private void loadContests() &#123;
        client.get("/sdk/app/contest/all", null, new ApiCallback&lt;List&lt;Contest&gt;&gt;() &#123;
            &#64;Override
            public void onSuccess(ApiResponse&lt;List&lt;Contest&gt;&gt; response) &#123;
                runOnUiThread(() -&gt; &#123;
                    // Update UI with contests
                    updateContestList(response.getData());
                &#125;);
            &#125;

            &#64;Override
            public void onError(LuqtaException e) &#123;
                Log.e("Luqta", "Load failed: " + e.getMessage());
            &#125;
        &#125;);
    &#125;
&#125;</code></pre>
        </div>
      </div>
    </section>
  </main>
</div>
